<template>
  <fieldset :class="[baseCss, `shadow-${elevation}`, rounded ? 'rounded' : null, paddingOff ? null : 'p-2', `text-${legendAlign}`, setBgColor()]">
    <legend v-html="legend" v-if="legend" :class="['truncate', rounded ? 'rounded' : null, setBgColor('legendBgColor', 'legendBgColorLightness'), setTextColor('legendColor', 'legendColorLightness', 'legendBgColorLightness'), 'inline-block', 'select-none', 'align-middle', 'px-2', 'py-0', 'mx-2', `text-${legendFontSize}`]" />
    <container :class="[`text-${contentAlign}`]">
      <slot />
    </container>
  </fieldset>
</template>
<script>
import methods from '../../mixins/methods'
import props from '../../mixins/props'

export default {
  name: 'FormGroup',
  mixins: [
    props,
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('form-group', [])
    }
  },
  props: {
    legendAlign: {
      type: String,
      default: 'auto',
      validator: value => {
        return ['left', 'center', 'right', 'auto'].includes(value)
      }
    },
    legendFontSize: {
      type: String,
      default: 'xs',
      validator: value => {
        return ['xs', 'md', 'sm', 'base', 'lg', 'xl', '2xl', '3xl', '4xl', '5xl', '6xl', '7xl', '8xl', '9xl'].includes(value)
      }
    },
    contentAlign: {
      type: String,
      default: 'auto',
      validator: value => {
        return ['left', 'center', 'justify', 'right', 'auto'].includes(value)
      }
    },
    legend: {
      type: String
    },
    rounded: {
      type: Boolean,
      default: true
    },
    paddingOff: {
      type: Boolean
    },
    legendBgColor: {
      type: String
    },
    legendBgColorLightness: {
      type: Number
    },
    bgColor: {
      type: String
    },
    bgColorLightness: {
      type: Number
    },
    legendColor: {
      type: String
    },
    legendColorLightness: {
      type: String
    }
  }
}
</script>
<style>
.bcq-ui-theme-dark .bcq-form-group,
.bcq-ui-theme-dark .bcq-form-group legend
{
  border: solid 1px var(--semi-transparent-light);
}

.bcq-form-group,
.bcq-form-group legend
{
  border: solid 1px var(--semi-transparent-dark);
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/form-group/form-group.vue